<template>
  <div class="nameDetail">
    <div class="detailTop" v-if="dataList[Math.abs(rowIndex)]">
      <div class="topImg">
        <div class="title">结果图</div>
        <img :src="dataList[Math.abs(rowIndex)].imageUrl" />
        <div class="imgTop"></div>
        <div class="imgbottom">
          <span>{{ dataList[Math.abs(rowIndex)].deviceName }}</span>
          <span>{{
            formatDateHMSSJC(dataList[Math.abs(rowIndex)].snapTime)
          }}</span>
        </div>
      </div>
      <div class="topTable">
        <div class="title" style="margin-left: 34px">抓拍结构化信息</div>
        <div class="textTable">
          <div class="tableTr" v-for="(item, index) in column" :key="index">
            <div class="tableTd">
              {{ item.label }}
            </div>
            <div class="tableTdd">
              <span v-if="dataList[Math.abs(rowIndex)][item.prop]">
                <!-- {{ parseInt(dataList[Math.abs(rowIndex)][item.prop]) }} -->
                {{
                  isNaN(parseInt(dataList[Math.abs(rowIndex)][item.prop]))
                    ? dataList[Math.abs(rowIndex)][item.prop]
                    : dataList[Math.abs(rowIndex)][item.prop] == 0
                    ? "否"
                    : "是"
                }}
              </span>
              <span v-else>--</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detailBottom">
      <div class="left">
        <el-button
          :disabled="Math.abs(rowIndex) + 1 === 1"
          circle
          @click="leftClick"
          type="primary"
          class="iconfont icon-xiangzuojiantou"
        ></el-button>
      </div>
      <div class="Bottomdetail">
        <div
          class="weiyi"
          style="width: 100%"
          :style="{ transform: `translateX(${140 * rowIndex}px)` }"
        >
          <div
            :class="{ detailImgHover: Math.abs(rowIndex) === index }"
            class="detailImg"
            v-for="(item, index) in dataList"
            :key="index"
            @click="detailClick(-index)"
          >
            <img :src="item.imagePartUrl" />
          </div>
        </div>
      </div>
      <div class="right">
        <el-button
          :disabled="Math.abs(rowIndex) + 1 === dataList.length"
          circle
          @click="rightClick"
          type="primary"
          class="iconfont icon-xiangyoujiantou"
        ></el-button>
      </div>
    </div>
    <div class="textBottom">
      {{ Math.abs(rowIndex) + 1 }}/{{ dataList.length }}
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  watchEffect,
  onMounted,
  nextTick,
  reactive,
  toRefs,
  toRaw,
  ref,
  inject,
} from "vue";
import { formatDateHMSSJC } from "@/utils/index.js";
export default defineComponent({
  name: "HNameDetail",
  props: {
    itemRow: {
      type: Object,
      default: () => {},
    },
    itemRowIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const data = reactive({
      imgURL: window.imgURL,
      activeName: "",
      activeNamery: "",
      dataList: [],
      rowItem: {},
      rowIndex: 0,
      column: [],
    });
    watchEffect(() => {
      data.rowIndex = props.itemRowIndex;
      data.rowItem = props.itemRow;
      if (props.itemRow.ageLowerLimit && props.itemRow.ageUpLimit) {
        data.rowItem.age =
          "约" +
          props.itemRow.ageLowerLimit +
          "--" +
          props.itemRow.ageUpLimit +
          "岁";
      }
    });
    const detailClick = (index) => {
      data.rowIndex = index;
    };
    const rightClick = () => {
      data.rowIndex--;
    };
    const leftClick = () => {
      //       if(){
      data.rowIndex++;
      //         data.rowIndex
      //       }
      // dataList
    };
    data.dataList = inject("dataList");
    data.activeName = inject("activeName");
    data.activeNamery = inject("activeNamery");
    if (data.activeName === "first" || data.activeNamery === "dataListrt") {
      data.column = [
        {
          prop: "age",
          label: "年龄",
        },
        {
          prop: "genderDict",
          label: "性别",
        },
        // {
        //   prop: "ethicCode",
        //   label: "民族",
        // },
        {
          prop: "glasses",
          label: "是否戴眼镜",
        },
        {
          prop: "respirator",
          label: "是否戴口罩",
        },
        {
          prop: "cap",
          label: "是否戴帽子",
        },
      ];
    } else if (
      data.activeName === "second" ||
      data.activeName === "fourth" ||
      data.activeNamery === "dataListrn"
    ) {
      data.column = [
        {
          prop: "age",
          label: "年龄段",
        },
        {
          prop: "genderDict",
          label: "性别",
        },
        {
          prop: "coatColorDict",
          label: "上衣颜色",
        },
        {
          prop: "trousersColorDict",
          label: "裤子颜色",
        },
        {
          prop: "coatLengthDict",
          label: "上衣长度",
        },
        {
          prop: "trousersLen",
          label: "裤子长度",
        },
        {
          prop: "coatStyleDict",
          label: "上衣款式",
        },
        {
          prop: "trousersStyleDict",
          label: "裤子款式",
        },
        {
          prop: "coatGrainDict",
          label: "上衣纹理",
        },
        // {
        //   prop: "cap",
        //   label: "是否骑行",
        // },
        {
          prop: "carryThings",
          label: "是否背包",
        },
        {
          prop: "cap",
          label: "是否戴帽子",
        },
      ];
    }
    return {
      ...toRefs(data),
      rightClick,
      detailClick,
      leftClick,
      formatDateHMSSJC,
    };
  },
});
</script>
<style lang="scss" scoped>
.nameDetail {
  .detailTop {
    height: 400px;
    display: flex;
    .topImg {
      width: 65%;
      height: 100%;
      position: relative;
      .imgTop {
        position: absolute;
        top: 0;
        width: 100%;
      }
      .imgbottom {
        position: absolute;
        color: #fff;
        bottom: -25px;
        width: 100%;
        background: rgba(26, 44, 101, 0.8);
        line-height: 24px;
        display: flex;
        justify-content: space-between;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .topTable {
      height: 100%;
      width: 30%;
      .textTable {
        width: 100%;
        height: 100%;
        border: 1px solid #dcdee3;
        border-radius: 4px;
        margin-left: 34px;
        overflow-x: auto;
        .tableTr {
          height: 48px;
          line-height: 48px;
          display: flex;
          border: 1px solid #dcdee3;
          text-align: left;
          .tableTd {
            background: #f2f2f2;
            width: 95px;
            text-indent: 15px;
          }
          .tableTdd {
            flex-grow: 1;
            -ms-flex-negative: 1;
            flex-shrink: 1;
            -ms-flex-preferred-size: auto;
            flex-basis: auto;
            padding: 15px;
            line-height: 16px;
            overflow: hidden;
          }
        }
      }
    }
  }
  .detailBottom {
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    .left {
      width: 5%;
      text-align: center;
      cursor: pointer;
    }
    .right {
      width: 5%;
      text-align: center;
      cursor: pointer;
    }
    .Bottomdetail {
      width: 90%;
      overflow: hidden;
      margin-bottom: 10px;
      margin-top: 33px;
      .weiyi {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      .detailImgHover {
        border: 1px solid #5584ff !important;
      }
      .detailImg {
        margin: 0 20px;
        border: 1px solid #cecece;
        height: 120px;
        padding: 10px;
        border-radius: 10px;
        img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }
  .textBottom {
    text-align: center;
  }
  .title {
    position: relative;
    padding-left: 11.5px;
    color: #333;
    font-weight: 600;
    font-size: 14px;
    height: 25px;
    line-height: 20px;
  }
  .title:before {
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: 3.5px;
    height: 14px;
    margin-top: -7px;
    background-color: #5584ff;
    content: " ";
  }
}
</style>
